import React from 'react';
import { Query, useMutation } from 'react-apollo';
import Helmet from 'react-helmet';
import { GET_TEMPLATES, DELETE_TEMPLATE } from 'graphql/timeline-templates';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Spin from 'components/common/Spin';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Link } from 'react-router-dom';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { IconButton, Tooltip } from '@material-ui/core';
import withConfirm from 'hooks/withConfirm';
import useSnack from 'hooks/useSnack';
import { useSelector } from 'react-redux';

const Templates = ({confirm, canEdit}) => {
  const user = useSelector((s) => s.user.user);
  const snack = useSnack();
  const [deleteTemplate] = useMutation(DELETE_TEMPLATE);

  const handleDelete = (e, id) => {
    e.preventDefault();
    confirm(
      () => {
        return deleteTemplate({
          variables: { id },
          update: (proxy) => {
            const  { rows }  = proxy.readQuery({
              query: GET_TEMPLATES,
            });
            proxy.writeQuery({
              query: GET_TEMPLATES,
              data: {
                rows: rows.filter((i) => i.id !== id),
              },
            });
          },
        }).then(
          () => snack.success('Template deleted'),
          (e) => snack.error(e.message),
        );
      },
      {
        title: 'Remove Template',
        description: 'Do you want to remove the Template?',
        confirmationText: 'Remove Template',
        confirmButtonProps: {
          variant: 'contained',
          color: 'secondary',
        },
      },
    );
  };
  return (
    <Query query={GET_TEMPLATES} fetchPolicy="cache-and-network">
      {({ data, loading }) => {
        if (loading) return <Spin spinning linear />;
        return (
          <Box>
            <Helmet title="Milestone templates" />
            <List disablePadding>
              {data.rows.map((i) => (
                <ListItem
                  button
                  divider
                  component={Link}
                  to={`/timeline-templates/${i.id}`}
                >
                  <ListItemText primary={i.name} />
                {canEdit &&
                    <Link to={`/timeline-templates/duplicate/${i.id}`}>
                      <Tooltip title="Duplicate">
                        <IconButton
                          color="secondary"
                        >
                          <FileCopyOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  }
                  {canEdit &&
                    <Tooltip title="Delete">
                      <IconButton
                        color="secondary"
                        onClick={(e) => handleDelete(e, i.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>}
                </ListItem>
              ))}
            </List>
            {canEdit && <Box className="text_center" marginTop={3}>
              <Link to="/timeline-templates/create">
                <Button color="primary" variant="outlined">
                  Add Template
                </Button>
              </Link>
            </Box>}
          </Box>
        );
      }}
    </Query>
  );
};

export default withConfirm(Templates);
